module.exports = __webpack_public_path__ + "static/img/xixiangLogo.c81a11e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/xixiangLogo.png
// module id = /JHz
// module chunks = 67